var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-18_error_filled"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 204",
    cx: 9,
    cy: 9,
    r: 7.5,
    fill: "#DC3545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M8.99437 4.70508C9.48893 4.70508 9.88626 5.11272 9.87358 5.60713L9.76359 9.89673C9.75289 10.3139 9.41165 10.6465 8.99437 10.6465C8.57708 10.6465 8.23584 10.3139 8.22514 9.89673L8.11515 5.60713C8.10248 5.11272 8.4998 4.70508 8.99437 4.70508ZM8.02171 12.3105C8.00999 11.7715 8.4553 11.332 9.00609 11.3379C9.52757 11.332 9.97874 11.7715 9.97874 12.3105C9.97874 12.8555 9.52757 13.2949 9.00609 13.2949C8.4553 13.2949 8.00999 12.8555 8.02171 12.3105Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorFilled);
export default __webpack_public_path__ + "static/media/icon_error_filled.c9b29fa78d84ef4c5ed30342a91ab140.svg";
export { ForwardRef as ReactComponent };